import AlbumCard from './AlbumCard';
import GlitchText from './effects/GlitchText';
import { albums } from '../data/albums';

export default function HomePage() {
  return (
    <div>
      <h1 className="page-title">
        <GlitchText>ΑΡΜΑΓΕΔΔΩΝ: Η ΤΡΙΛΟΓΙΑ</GlitchText>
      </h1>
      <p className="page-subtitle">
        Η επιστήμη απέτυχε. Οι ήρωες άργησαν. Η Γη καταστρέφεται. Και εμείς; Στήνουμε ηχεία, γεμίζουμε ποτήρια και βάζουμε τέρμα τη μουσική. Αν αυτό είναι το τέλος της ανθρωπότητας, τουλάχιστον θα έχει ένα πολύ καλό soundtrack.
      </p>
      <div className="card-grid">
        {albums.map((a) => <AlbumCard key={a.id} album={a} />)}
      </div>
    </div>
  );
}
